module.exports = __webpack_public_path__ + "img/icon_live_re.574247ee.svg";